import { BrowserRouter as Router, Route, Routes, } from 'react-router-dom'

import Navbar from "./components/header";
import Footer from "./components/footer";

import Home from "./pages/index";


export default function Routers () {
    return (
      <Router>
          <Navbar />
           <Routes>
                <Route path="/" exact element={<Home/>}/>
          </Routes>
          <Footer/>
       </Router>
      )
}